module.exports = __webpack_public_path__ + "img/earth-card.0647ebc.webp";